import fireworks from "./fireworks.js";
import fireworks2 from "./fireworks2.js";
import fontawesome from "./fontawesome.js";
import forward from "./forward.js";
export default {
    fireworks,
    fireworks2,
    fontawesome,
    forward,
};
